<template>
  <div class="d-flex">
    <div class="col-md-3" v-if="!details" >
      <Search :calcularTotalDespesaViagemUsuario="calcularTotalDespesaViagemUsuario" :funcionarioidRota="funcionarioidRota" @onLoadFuncionario="onLoadFuncionario"></Search>
    </div>
    <div class="col-md-9" v-if="!details">
      <!-- ZC-44: Log tambem AQUI, antes de entrar na despesa, igual a tela de Diversos. b-tabs SEM
           v-if e SEM lazy: o pai usa o `ref="table"`, e desmontar o Table quebraria a acao dos
           botoes da grid. -->
      <b-tabs>
      <b-tab :title="'Lista de Despesa'">
        <template slot="title">
          <i class="fas fa-list-ul text-third"></i><span class="d-md-down-none pl-1 text-third"> Lista de Despesa</span>
        </template>
        <Table :dataExpenseDetails="dataExpenseDetails" ref="table" @onSelect="onSelect" @setdespesasexpense="setdespesasexpense"></Table>
      </b-tab>
      <b-tab :title="'Log'">
        <template slot="title">
          <i class="fas fa-tasks text-third"></i><span class="d-md-down-none pl-1 text-third"> Log</span>
        </template>
        <div class="p-3">
          <div class="subtitle mb-3">Log de Status das despesas listadas</div>
          <!-- os ids vem da GRID (`setdespesasexpense`, que o Table ja emitia), nao de
               funcionario+empresa: a grid filtra por perfil e pagina -->
          <LogDespesa :despesa-ids="idsDasDespesasNaGrid" modulo="viagem" />
        </div>
      </b-tab>
      </b-tabs>
    </div>
    <div class="col-md-12" v-if="details">
      <!-- <Details :dataExpenseDetails="dataExpenseDetails" @AtualizaInfo="setAtualizaInfo"></Details> -->
      <Details :dataExpenseDetails="dataExpenseDetails" @voltarGrid="details = false"></Details>
    </div>
  </div>

</template>

<script>
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import Details from './components/details/details.vue'
import Search from './components/search/search.vue'
import Table from './components/table/table.vue'
import LogDespesa from '@/views/private/miscellaneousreimbursement/components/LogDespesa/LogDespesa.vue'
export default {
  name: 'TrevelExpenseEmployee',
  mixins: [ActionsForm],
  components: {Search, Table, Details, LogDespesa},
  data () {
    return {
      funcionarioid: null,
      funcionarioidRota: null,
      objList: [],
      dataexpenses: [],
      midiapdf: null,
      indexFuncionarioDespesa: null,
      dataStatusDespesa: [],
      despesaviagemid: null,
      dataExpenseDetails: [],
      details: false,
      dataEnumCategoria: [],
      dataSubCategoriaVeiculo: [],
      dataSubCategoria: []
    }
  },
  watch: {
    'dataFormSearch.categoria': function (newvalue) {
      this.dataFormSearch.subcategoria = null
    }
  },
  computed: {
    // ZC-44: os ids que a GRID carregou, que sao os que a aba Log pede ao servidor. Sai do
    // `setdespesasexpense` que o Table ja emitia, entao acompanha perfil, filtro e paginacao sem
    // esta tela ter de saber nada disso.
    idsDasDespesasNaGrid () {
      return Array.isArray(this.dataexpenses) ? this.dataexpenses.map((d) => d && d.id).filter(Boolean) : []
    },
    calcularTotalDespesaViagemUsuario: function () {
      let totalController = 0
      let totalCoordinator = 0
      let totalDirectory = 0
      let totalControllerDescricao = null
      let totalCoordinatorDescricao = null
      let totalDirectoryDescricao = null
      let totalTecnico = 0
      let totalTecnicoDescricao = null
      let localidade = null
      if (this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.dataexpenses.forEach((Element) => {
          if (Element.statusDespesa === 2) {
            totalControllerDescricao = Element.statusDespesaDescricao
            totalController += Element.valor
          }
        })
      }
      if (this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.dataexpenses.forEach((Element) => {
          if (Element.statusDespesa === 1) {
            totalCoordinatorDescricao = Element.statusDespesaDescricao
            totalCoordinator += Element.valor
          }
        })
      }
      if (this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.dataexpenses.forEach((Element) => {
          if (Element.statusDespesa === 3) {
            totalDirectoryDescricao = Element.statusDespesaDescricao
            totalDirectory += Element.valor
          }
        })
      }
      if (this.hasRole(this.roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.dataexpenses.forEach((Element) => {
          if (Element.statusDespesa === 9) {
            totalTecnicoDescricao = Element.statusDespesaDescricao
            totalTecnico += Element.valor
          }
        })
      }
      this.dataexpenses.forEach((Element) => {
        localidade = Element.localidade
      })
      return {
        totalControllerDescricao: totalControllerDescricao,
        totalCoordinatorDescricao: totalCoordinatorDescricao,
        totalDirectoryDescricao: totalDirectoryDescricao,
        totalController: totalController,
        totalCoordinator: totalCoordinator,
        totalDirectory: totalDirectory,
        totalTecnico: totalTecnico,
        totalTecnicoDescricao: totalTecnicoDescricao,
        localidade: localidade
      }
    }
  },
  mounted () {
    this.FuncionarioIdRota()
  },
  methods: {
    FuncionarioIdRota () {
      var url = new URL(window.location.href)

      this.funcionarioidRota = url.searchParams.get('funcionario')
    },
    onLoadFuncionario (data) {
      localStoreHelper.viagem.prestacaoContasDetalhes(data)
      this.$refs.table.onLoadFuncionario(data)
    },

    setdespesasexpense  (data) {
      this.dataexpenses = data
    },
    addfuncionario () {
      let data = {
        funcionario: {
          nome: null,
          codigo: null
        },
        funcionarioid: null,
        id: null
      }
      this.dataExpenseDetails.funcionarioVinculados.push(data)
    },
    async GetByidDetails () {
      if (this.despesaviagemid) {
        loading.push()
        await TravelExpenseRepository.GetByidDetails(this.despesaviagemid)
          .then((Response) => {
            loading.pop()
            this.dataExpenseDetails = Response.data
            this.details = true
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    },
    PostDetalhes () {
      loading.push()
      let formdata = new FormData()
      formdata.append('despesasPostDetailsDtoJson', JSON.stringify(this.dataExpenseDetails))
      TravelExpenseRepository.PostDetalhes(formdata)
        .then((Response) => {
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onSelect (data) {
      if (data.adiantamento) return
      this.despesaviagemid = data.id
      this.GetByidDetails()
    },
    // onClear () {
    //   Object.keys(this.dataFormSearch).forEach((Element) => {
    //     this.dataFormSearch[Element] = null
    //   })
    // },
    searchFuncionario (e, index) {
      this.indexFuncionarioDespesa = index
      loading.push()
      EmployeeRepository.GetByCode(this.CompanySelected, e.target.value)
        .then((Response) => {
          if (Response.data.code === 200) {
            this.dataExpenseDetails.funcionarioVinculados[this.indexFuncionarioDespesa].funcionarioid = Response.data.data.id
            this.dataExpenseDetails.funcionarioVinculados[this.indexFuncionarioDespesa].funcionario.nome = Response.data.data.nome
          } else {
            toast.error('Não foi possivel encontrar funcionario')
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    }
  }
}
</script>

  <style scoped>

    .label-search{
      padding-bottom: 0px;
      margin-bottom: 0px;
      margin-top: 10px;
      font-weight: bold;
    }

    #add-more-people{
      color: rgb(0, 183, 255);
      text-decoration: underline;
      cursor: pointer;
    }
    .campos{
      margin-top: 10px;
    }
    .btn-appr{
      width: 10vw;
      background: #008144;
      color: white;
      margin-left: 5px;
      border: none;
      border-radius: 5px;
      font-weight: bold;
    }

    .btn-rep{
      width: 10vw;
      background: red;
      margin-right: 5px;
      color: white;
      border: none;
      border-radius: 5px;
      font-weight: bold;
    }
    .coluna-center{
      display: flex;
      padding: 0px;
      height: 100%;
      align-items: center;
      margin: 0px;
      justify-content: center;
    }
    .buttonaprova{
      height: 45px;
      display: flex;
    }

  </style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/trevelexpenseemployee.vue